import React, { createContext, useState } from 'react';
import useEpisodePlayersContext from '../../../hooks/useEpisodePlayersContext';
const PlayersContext = createContext();

const AppProviderPlayer = ({ children, episodeIndex }) => {
    const [showDescription, setShowDescription] = useState(false);
    const { activeEpisodeIndex, clickedButtonIndex } = useEpisodePlayersContext();

    const [showPopupSubscribe, setShowPopupSubscribe] = useState(false);
    const [showPopupEmbed, setShowPopupEmbed] = useState(false);
    const [showPopupShare, setShowPopupShare] = useState(false);

    const closeAllPopups = () => {
        if(showPopupSubscribe) {
            setShowPopupSubscribe(false);
        }
        if(showPopupEmbed) {
            setShowPopupEmbed(false);
        }
        if(showPopupShare) {
            setShowPopupShare(false);
        }
    }

    const popupShare = () => {
        setShowPopupShare(!showPopupShare);
    };

    const popupEmbed = () => {
        setShowPopupEmbed(!showPopupEmbed);
    };

    const popupSubscribe = () => {
        setShowPopupSubscribe(!showPopupSubscribe);
    };

    return (
        <PlayersContext.Provider
            value={{
                showDescription,
                setShowDescription,
                episodeIndex,
                activeEpisodeIndex,
                clickedButtonIndex,

                showPopupSubscribe,
                setShowPopupSubscribe,

                showPopupEmbed,
                setShowPopupEmbed,

                showPopupShare,
                setShowPopupShare,

                closeAllPopups,
                popupShare,
                popupEmbed,
                popupSubscribe
            }}
        >
            {children}
        </PlayersContext.Provider>
    );
};

export { PlayersContext, AppProviderPlayer };
